/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Messages API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMessageResponse
 */
export interface CreateMessageResponse {
    /**
     * Array with UUIDs of the messages created
     * @type {Array<string>}
     * @memberof CreateMessageResponse
     */
    createdMessages: Array<string>;
}

export function CreateMessageResponseFromJSON(json: any): CreateMessageResponse {
    return CreateMessageResponseFromJSONTyped(json, false);
}

export function CreateMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMessageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdMessages': json['createdMessages'],
    };
}

export function CreateMessageResponseToJSON(value?: CreateMessageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdMessages': value.createdMessages,
    };
}


